import Link from "@material-ui/core/Link";
import React from "react";

export default function MailTo({ children }) {
  return <Link href={`mailto:${children}`}>{children}</Link>;
}
